(function () {
    'use strict';
    /**
    * @Controller
    * @name IbcoseModalDeepController
    * @desc Controller for the modal Deep instantiated in IBCOSE view
    */
    angular
        .module('ib-check-in-search')
        .controller('IbcoseModalDeepController', IbcoseModalDeepController);

    IbcoseModalDeepController.$inject = ['$uibModalInstance', 'UtilsService', '$sce', '$window', 'object', 'ModalService', 'CkiDatalayerConstants', 'CkiDataLayerService'];
    function IbcoseModalDeepController($uibModalInstance, UtilsService, $sce, $window, object, ModalService, CkiDatalayerConstants, CkiDataLayerService) {

        var vm = this;
        vm.close = close;
        vm.url = (UtilsService.getDeviceType() === 'mobile') ? object.externalMobileUrl : object.externalUrl;
        vm.goDescription = object.externalCompany.description;
        vm.message = $sce.trustAsHtml(object.message);
        vm.openurl = openurl;
        vm.model = object;
        vm.deeplinkDigitalData = deeplinkDigitalData;
        ModalService.isNotWaiting();

        activate();

        function activate () {
            vm.deeplinkDigitalData();
        }


        function deeplinkDigitalData () {
            const source = vm.model.externalCompany.code;
            if (angular.isString(source) && source.length >= 2) {
                const digital_data = {};
                digital_data[CkiDatalayerConstants.DIGITAL_DATA_INFO.DEEPLINK] = source;
                CkiDataLayerService.addDigitalDataInfo(digital_data);
            }
        };

        //Close the modal
        function close() {
            ModalService.isWaiting();
            $uibModalInstance.dismiss('cancel');
        }

        function openurl() {
            $window.location.href = vm.url;
        }
    }
})();
